const productSticky = document.querySelector(".product-sticky");
const firstSection = document.querySelector("product-form.product-form") 
? document.querySelector("product-form.product-form") 
: document.querySelector("#MainContent").children[0];

let lastScrollPos = window.pageYOffset;
let isScrolling = false;
let scrollTimeout;

function toggleStickyElement() {
  const currentScrollPos = window.pageYOffset;
  const isLineCrossing = currentScrollPos <= firstSection.offsetTop - 50 ? false : true 
  productSticky.classList.toggle("_hide", !isLineCrossing);

  // if (currentScrollPos > lastScrollPos) {
  //   productSticky.classList.remove("_hide");
  // } else {
  //   // productSticky.classList.add("_hide");
  //   if (currentScrollPos <= firstSection.offsetTop) {
  //     productSticky.classList.add("_hide");
  //   }
  // }

  // lastScrollPos = currentScrollPos;

}

function handleScroll() {

  if (!isScrolling) {
    productSticky.classList.remove("_hide");
  }

  isScrolling = true;

    isScrolling = false;
    toggleStickyElement();
}

if (firstSection) {
  toggleStickyElement();
  window.addEventListener("scroll", handleScroll);
}


const linksCheckout = document.querySelector(".link__btn");
const currentId = productSticky.dataset.productid

linksCheckout.addEventListener("click", async function (event) {
    event.preventDefault();

    let updates = {
        id: currentId,
        quantity: 1
    };

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(updates)
        });

        if (response.ok) {
            window.location.href = "/checkout";
        } else {
            console.error('Error:', response.status);
        }
        const json = await response.json();
    } catch (err) {
        console.error('Error:', err);
    }
});


